import { useQuery } from '@tanstack/react-query';
import { fetchActiveFundCommitments } from '../../api/finance';

export const useActiveFundCommitments = (options = {}) => {
  const query = useQuery({
    queryKey: ['fundCommitments', 'active'],
    queryFn: () => fetchActiveFundCommitments(),
    enabled: options.enabled !== false,
  });

//   console.log(query.data?.data?.fundCommitments);

  return {
    ...query,
    fundCommitments: query.data?.data?.fundCommitments ?? [],
  };
};

export default useActiveFundCommitments;
